import { render } from "./RichThisWeekTabCont.vue?vue&type=template&id=4ebeee80"
import script from "./RichThisWeekTabCont.vue?vue&type=script&lang=js"
export * from "./RichThisWeekTabCont.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__